import 'core-js/es/map';
import 'core-js/es/symbol';
import 'core-js/es/object';
import { __awaiter } from 'tslib';
import { uniq } from 'lodash';
import { BehaviorSubject, Subject, merge, fromEvent, of, from, combineLatest } from 'rxjs';
import { map, switchMap, delay, takeUntil, filter, take, flatMap, scan } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const ProgressState = {
    NotStarted: 0,
    Idle: 1,
    InProgress: 2,
    Completed: 3,
    Failed: 4,
    Cancelled: 5,
};
ProgressState[ProgressState.NotStarted] = 'NotStarted';
ProgressState[ProgressState.Idle] = 'Idle';
ProgressState[ProgressState.InProgress] = 'InProgress';
ProgressState[ProgressState.Completed] = 'Completed';
ProgressState[ProgressState.Failed] = 'Failed';
ProgressState[ProgressState.Cancelled] = 'Cancelled';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const HttpMethod = {
    Get: 'GET',
    Head: 'HEAD',
    Post: 'POST',
    Put: 'PUT',
    Delete: 'DELETE',
    Connect: 'CONNECT',
    Options: 'OPTIONS',
    Trace: 'TRACE',
    Patch: 'PATCH',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const uploadSuccessOrRedirectCode = /^[23]/;
/**
 * @record
 */
function IFileUpload() { }
if (false) {
    /**
     * The state and percentage of the file's upload progress.
     * @type {?}
     */
    IFileUpload.prototype.progress;
    /**
     * The response, if any, returned from the HTTP upload call.
     * @type {?}
     */
    IFileUpload.prototype.response;
    /**
     * The code from the HTTP response, if any (e.g. `200`).
     * @type {?}
     */
    IFileUpload.prototype.responseCode;
    /**
     * The HTTP response body, if any.
     * @type {?}
     */
    IFileUpload.prototype.responseBody;
    /**
     * Set to `true` the first time the file upload is executed.
     * @type {?}
     */
    IFileUpload.prototype.uploadHasStarted;
    /**
     * Receives a value every time the FileUpload is supposed to execute its HTTP upload.
     * @type {?}
     */
    IFileUpload.prototype.executeStream;
    /**
     * Receives `false` when `markForRemoval()` is called, telling `Uploader` to delete it
     * from memory and cancel the upload if one is pending.
     * @type {?}
     */
    IFileUpload.prototype.isMarkedForRemovalStream;
    /**
     * Returns the value passed to `setRequestOptions()`.
     * @type {?}
     */
    IFileUpload.prototype.requestOptions;
    /**
     * A unique identifier for the `FileUpload`.
     * @type {?}
     */
    IFileUpload.prototype.id;
    /**
     * The `name` taken from `file.name`.
     * @type {?}
     */
    IFileUpload.prototype.name;
    /**
     * Percentage of the upload that has been completed.
     * @type {?}
     */
    IFileUpload.prototype.progressPercentage;
    /**
     * Boolean indicating whether an upload is in progress.
     * @type {?}
     */
    IFileUpload.prototype.uploading;
    /**
     * Boolean indicating whether the upload has completed, either successfully or not.
     * @type {?}
     */
    IFileUpload.prototype.uploaded;
    /**
     * Boolean indicating whether the upload has succeeded.
     * @type {?}
     */
    IFileUpload.prototype.succeeded;
    /**
     * Boolean indicating whether the upload has failed.
     * @type {?}
     */
    IFileUpload.prototype.failed;
    /**
     * Boolean indicating whether the upload has been marked as a failure by `Uploader`.
     * @type {?}
     */
    IFileUpload.prototype.rejected;
    /**
     * Boolean indicating whether the `FileUpload` has been marked for deletion by `Uploader`.
     * @type {?}
     */
    IFileUpload.prototype.isMarkedForRemoval;
    /**
     * Used by `Uploader` to mark a `FileUpload` as failed.
     * @param {?=} errorResponse
     * @return {?}
     */
    IFileUpload.prototype.reject = function (errorResponse) { };
    /**
     * Set the `IUploadRequestOptions`, used to construct the HTTP request.
     * @param {?} options
     * @return {?}
     */
    IFileUpload.prototype.setRequestOptions = function (options) { };
    /**
     * Used by `Uploader` to construct the HTTP request.
     * @return {?}
     */
    IFileUpload.prototype.createRequest = function () { };
    /**
     * Resets the state of the `FileUpload`.
     * @return {?}
     */
    IFileUpload.prototype.reset = function () { };
    /**
     * Executes the file upload.
     * @return {?}
     */
    IFileUpload.prototype.retry = function () { };
    /**
     * Used by `Uploader` to mark the `FileUpload` for deletion.
     * @return {?}
     */
    IFileUpload.prototype.markForRemoval = function () { };
    /**
     * Alias for {\@link IFileUpload#markForRemoval}`
     * @return {?}
     */
    IFileUpload.prototype.remove = function () { };
}
class FileUpload {
    /**
     * @param {?} file
     * @param {?=} id
     */
    constructor(file, id) {
        this.file = file;
        this._requestOptions = {
            url: (/** @type {?} */ (null)),
            method: HttpMethod.Post,
            formData: null
        };
        this._executeSubject = new BehaviorSubject(null);
        this._isMarkedForRemovalSubject = new BehaviorSubject(false);
        // Public API.
        this.progress = {
            percent: 0,
            state: ProgressState.NotStarted
        };
        this.uploadHasStarted = false;
        this.executeStream = this._executeSubject.asObservable();
        this.isMarkedForRemovalStream = this._isMarkedForRemovalSubject.asObservable();
        this._id = id || Symbol(file.name);
    }
    // Getters.
    /**
     * @return {?}
     */
    get requestOptions() {
        return this._requestOptions;
    }
    /**
     * @return {?}
     */
    get id() {
        return this._id;
    }
    /**
     * @return {?}
     */
    get name() {
        return this.file ? this.file.name : '';
    }
    /**
     * @return {?}
     */
    get progressPercentage() {
        return this.progress.percent;
    }
    /**
     * @return {?}
     */
    get uploading() {
        return !this.uploaded && !this.failed && this.progress.state === ProgressState.InProgress;
    }
    /**
     * @return {?}
     */
    get uploaded() {
        return !this.failed && this.progress.state === ProgressState.Completed;
    }
    /**
     * @return {?}
     */
    get succeeded() {
        return this.uploaded;
    }
    /**
     * @return {?}
     */
    get failed() {
        if (!!this.response) {
            if (this.response && this.response.status) {
                return !this.response.status.toString().match(uploadSuccessOrRedirectCode);
            }
        }
        if (!!this.responseCode) {
            return !this.responseCode.toString().match(uploadSuccessOrRedirectCode);
        }
        return this.progress.state === ProgressState.Failed || this.rejected;
    }
    /**
     * @return {?}
     */
    get rejected() {
        return this._rejected;
    }
    /**
     * @return {?}
     */
    get isMarkedForRemoval() {
        return this._isMarkedForRemovalSubject.getValue();
    }
    /**
     * @param {?=} errorResponse
     * @return {?}
     */
    reject(errorResponse) {
        if (errorResponse) {
            this.response = errorResponse;
        }
        this._rejected = true;
    }
    /**
     * @param {?} options
     * @return {?}
     */
    setRequestOptions(options) {
        this._requestOptions = Object.assign({}, this._requestOptions, options);
    }
    /**
     * @return {?}
     */
    createRequest() {
        // Create a new form.
        const { url, method, formData: body, headers } = this._requestOptions;
        /** @type {?} */
        const formData = new FormData();
        formData.append('file', this.file, this.file.name);
        if (body) {
            Object.keys(body).forEach((/**
             * @param {?} key
             * @return {?}
             */
            (key) => {
                formData.append(key, body[key]);
            }));
        }
        // Construct the request.
        return { method, url, body: formData, headers };
    }
    /**
     * @return {?}
     */
    createRequestFileAsBody() {
        const { url, headers, method } = this._requestOptions;
        // Construct the request.
        return { method, url, body: this.file, headers };
    }
    /**
     * @return {?}
     */
    reset() {
        this._rejected = false;
        this.response = null;
        this.responseBody = null;
        this.responseCode = null;
        this.progress.state = ProgressState.NotStarted;
        this.progress.percent = 0;
    }
    /**
     * @return {?}
     */
    retry() {
        this._executeSubject.next(null);
    }
    /**
     * @return {?}
     */
    markForRemoval() {
        this._isMarkedForRemovalSubject.next(true);
    }
    /**
     * @return {?}
     */
    remove() {
        this.markForRemoval();
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    FileUpload.prototype._id;
    /**
     * @type {?}
     * @private
     */
    FileUpload.prototype._rejected;
    /**
     * @type {?}
     * @private
     */
    FileUpload.prototype._requestOptions;
    /**
     * @type {?}
     * @private
     */
    FileUpload.prototype._executeSubject;
    /**
     * @type {?}
     * @private
     */
    FileUpload.prototype._isMarkedForRemovalSubject;
    /** @type {?} */
    FileUpload.prototype.progress;
    /** @type {?} */
    FileUpload.prototype.response;
    /** @type {?} */
    FileUpload.prototype.responseCode;
    /** @type {?} */
    FileUpload.prototype.responseBody;
    /** @type {?} */
    FileUpload.prototype.uploadHasStarted;
    /** @type {?} */
    FileUpload.prototype.executeStream;
    /** @type {?} */
    FileUpload.prototype.isMarkedForRemovalStream;
    /** @type {?} */
    FileUpload.prototype.file;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UploaderError extends Error {
}
class FileUploadError extends UploaderError {
}
class DisallowedContentTypeError extends FileUploadError {
}
class FileSizeLimitExceededError extends FileUploadError {
}
class MissingRequestOptionsError extends FileUploadError {
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} fileInputElement
 * @param {?} accept
 * @return {?}
 */
function setAcceptAttribute(fileInputElement, accept) {
    // For iOS, the accept attribute is broken, not allowing some filetypes when they should be allowed.
    // Solution is to not set the accept attribute if user is on an iOS device.
    // https://github.com/lionheart/openradar-mirror/issues/19227
    if (!!navigator.platform && !(/iPad|iPhone|iPod/.test(navigator.platform))) {
        fileInputElement.setAttribute('accept', accept);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const XHRReadyState = {
    UNSENT: 0,
    OPENED: 1,
    HEADERS_RECEIVED: 2,
    LOADING: 3,
    DONE: 4,
};
/** @type {?} */
const BYTES_PER_MB = 1000 * 1000;
/**
 * @template FileUploadType
 */
class Uploader {
    /**
     * @param {?=} config
     */
    constructor(
    /**
     * The `Uploader` constructor takes an optional config object.
     * Note: Passing a string to `config` is @deprecated as of v1.3 and will be removed
     * in a future version.
     */
    config) {
        this._isDraggedOverSubject = new BehaviorSubject(false);
        this._fileInputElements = [];
        this._fileDropZoneElements = [];
        this._fileUploadSubjectsMap = new Map();
        this._fileUploadsStreamResetSubject = new Subject();
        this._errorSubject = new Subject();
        this._areRequestOptionsSet = false;
        this._uploadFileAsBody = false;
        this._allowedContentTypes = ['*'];
        this._fileCountLimit = 0; // Anything falsy or < 1 means infinity.
        this._fileUploadType = FileUpload;
        this._dropZoneEventListenersMap = new Map();
        this._subscriptions = [];
        /**
         * A stream indicating whether the user is currently dragging files over any registered drop zone.
         */
        this.isDraggedOverStream = this._isDraggedOverSubject.asObservable();
        /**
         * A stream of any errors that occur during upload.
         */
        this.errorStream = this._errorSubject.asObservable();
        this._defaultFileSource = Uploader.createFileInputElement();
        this.errorStream.subscribe((/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            console.error(`[RxJs Uploader] ${error}`);
        }));
        if (config) {
            if (config !== 'single' && config !== 'multiple') {
                if (typeof config.allowedContentTypes !== 'undefined') {
                    this.setAllowedContentTypes(config.allowedContentTypes);
                }
                if (typeof config.fileCountLimit !== 'undefined') {
                    this.setFileCountLimit(config.fileCountLimit);
                }
                if (typeof config.fileSizeLimitMb !== 'undefined') {
                    this.setFileSizeLimitMb(config.fileSizeLimitMb);
                }
                if (typeof config.onFileCountLimitExceeded !== 'undefined') {
                    this.setOnFileCountLimitExceeded(config.onFileCountLimitExceeded);
                }
                if (typeof config.requestUrl !== 'undefined') {
                    this.setRequestUrl(config.requestUrl);
                }
                if (typeof config.requestOptions !== 'undefined') {
                    this.setRequestOptions(config.requestOptions);
                }
                if (typeof config.uploadFileAsBody !== 'undefined') {
                    this.setUploadFileAsBody(config.uploadFileAsBody);
                }
                if (typeof config.fileUploadType !== 'undefined') {
                    this.setFileUploadType(config.fileUploadType);
                }
                if (typeof config.allFilesQueuedCallback !== 'undefined') {
                    this.setAllFilesQueuedCallback(config.allFilesQueuedCallback);
                }
                if (typeof config.fileUploadedCallback !== 'undefined') {
                    this.setFileUploadedCallback(config.fileUploadedCallback);
                }
                if (typeof config.allFilesUploadedCallback !== 'undefined') {
                    this.setAllFilesUploadedCallback(config.allFilesUploadedCallback);
                }
                if (typeof config.dragAndDropFlagSelector !== 'undefined') {
                    this.setDragAndDropFlagSelector(config.dragAndDropFlagSelector);
                }
                if (typeof config.disallowedContentTypeErrorMessage !== 'undefined') {
                    this.setDisallowedContentTypeErrorMessage(config.disallowedContentTypeErrorMessage);
                }
                if (typeof config.disallowedContentSizeErrorMessage !== 'undefined') {
                    this.setDisallowedContentSizeErrorMessage(config.disallowedContentSizeErrorMessage);
                }
            }
            else {
                // TODO(dmayerdesign): Remove in v1.4.
                if (config === 'multiple') {
                    this._defaultFileSource.setAttribute('multiple', 'multiple');
                }
            }
        }
    }
    // Helper API.
    /**
     * Return an `HTMLInputElement` with the specified `accept`, and `className` attributes.
     * If called with no arguments, creates a single-file `input`.
     * @param {?=} type
     * @param {?=} accept
     * @param {?=} className
     * @return {?}
     */
    static createFileInputElement(type = 'single', accept, className) {
        /** @type {?} */
        const existingFileInputElements = document.querySelectorAll(`.${className}`);
        if (!!existingFileInputElements && !!existingFileInputElements.length) {
            Array.from(existingFileInputElements).forEach((/**
             * @param {?} existingFileInputElement
             * @return {?}
             */
            (existingFileInputElement) => {
                document.body.removeChild(existingFileInputElement);
            }));
        }
        /** @type {?} */
        const fileInputElement = document.createElement('input');
        if (className) {
            fileInputElement.className = className;
        }
        fileInputElement.setAttribute('type', 'file');
        if (type === 'multiple') {
            fileInputElement.setAttribute('multiple', 'multiple');
        }
        if (accept) {
            setAcceptAttribute(fileInputElement, accept);
        }
        fileInputElement.style.display = 'none';
        document.body.appendChild(fileInputElement);
        return fileInputElement;
    }
    // Uploader API.
    /**
     * Take one or more `FileSource`s (`input[type="file"]`s or drop zone target elements), or
     * one of `'single'` or `'multiple'` if you intend to use `Uploader`'s default file input.
     * @param {...?} fileSources
     * @return {?} an observable of `FileUpload`s, executing the uploads immediately (if an `allFilesQueuedCallback`
     * does not exist) or when the `allFilesQueuedCallback` returns or resolves.
     */
    streamFileUploads(...fileSources) {
        /** @type {?} */
        let _fileSources = (/** @type {?} */ (fileSources));
        if (!fileSources.length) {
            _fileSources = [this._defaultFileSource];
        }
        else if (fileSources[0] === 'single' || fileSources[0] === 'multiple') {
            if (fileSources[0] === 'single' && this._defaultFileSource.getAttribute('multiple')) {
                this._defaultFileSource.removeAttribute('multiple');
            }
            else if (fileSources[0] === 'multiple' && !this._defaultFileSource.getAttribute('multiple')) {
                this._defaultFileSource.setAttribute('multiple', 'multiple');
            }
            _fileSources = [this._defaultFileSource];
        }
        return this._streamFileUploads(this._registerSources(..._fileSources));
    }
    /**
     * Pipe an empty array to the stream returned by `streamFileUploads`, unsubscribe from all open
     * subscriptions, and set all associated file input elements' `value` property to `''`.
     * @return {?}
     */
    clear() {
        this._fileUploadsStreamResetSubject.next(null);
        this._fileUploadSubjectsMap.clear();
        this._subscriptions.forEach((/**
         * @param {?} subscription
         * @return {?}
         */
        (subscription) => subscription.unsubscribe()));
        this._fileInputElements.forEach((/**
         * @param {?} inputElement
         * @return {?}
         */
        (inputElement) => {
            inputElement.value = '';
        }));
    }
    /**
     * Call `.click()` on the default file input element (created and appended to <body> when Uploader
     * is instantiated). Useful when calling `streamFileUploads` with no arguments.
     * @return {?}
     */
    selectFiles() {
        this._defaultFileSource.click();
    }
    // Builder methods.
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} url
     * @return {THIS}
     */
    setRequestUrl(url) {
        if (!(/** @type {?} */ (this))._requestOptions) {
            (/** @type {?} */ (this))._requestOptions = {};
        }
        (/** @type {?} */ (this))._requestOptions = Object.assign({}, (/** @type {?} */ (this))._requestOptions, { url });
        (/** @type {?} */ (this))._areRequestOptionsSet = true;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?=} factoryOrOptions
     * @return {THIS}
     */
    setRequestOptions(factoryOrOptions) {
        if (typeof factoryOrOptions === 'function') {
            (/** @type {?} */ (this))._requestOptionsFactory = factoryOrOptions.bind((/** @type {?} */ (this)));
        }
        else {
            (/** @type {?} */ (this))._requestOptions = factoryOrOptions;
        }
        (/** @type {?} */ (this))._areRequestOptionsSet = true;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} factory
     * @return {THIS}
     */
    setRequestOptionsFactory(factory) {
        (/** @type {?} */ (this))._requestOptionsFactory = factory;
        (/** @type {?} */ (this))._areRequestOptionsSet = true;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?=} requestOptionsPatch
     * @return {THIS}
     */
    patchRequestOptions(requestOptionsPatch) {
        const { formData, url, method } = requestOptionsPatch;
        if (!(/** @type {?} */ (this))._requestOptions) {
            (/** @type {?} */ (this))._requestOptions = {};
        }
        if (requestOptionsPatch.formData) {
            (/** @type {?} */ (this))._requestOptions.formData = Object.assign({}, formData);
        }
        if (requestOptionsPatch.url) {
            (/** @type {?} */ (this))._requestOptions.url = url;
        }
        if (requestOptionsPatch.method) {
            (/** @type {?} */ (this))._requestOptions.method = method;
        }
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} contentTypes
     * @return {THIS}
     */
    setAllowedContentTypes(contentTypes) {
        (/** @type {?} */ (this))._allowedContentTypes = contentTypes;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} limit
     * @return {THIS}
     */
    setFileCountLimit(limit) {
        (/** @type {?} */ (this))._fileCountLimit = limit;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} limit
     * @return {THIS}
     */
    setFileSizeLimitMb(limit) {
        (/** @type {?} */ (this))._fileSizeLimitMb = limit;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} uploadFileAsBody
     * @return {THIS}
     */
    setUploadFileAsBody(uploadFileAsBody) {
        (/** @type {?} */ (this))._uploadFileAsBody = uploadFileAsBody;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} fn
     * @return {THIS}
     */
    setOnFileCountLimitExceeded(fn) {
        (/** @type {?} */ (this))._onFileCountLimitExceeded = fn;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} callback
     * @return {THIS}
     */
    setAllFilesQueuedCallback(callback) {
        (/** @type {?} */ (this))._allFilesQueuedCallback = callback;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} callback
     * @return {THIS}
     */
    setFileUploadedCallback(callback) {
        (/** @type {?} */ (this))._fileUploadedCallback = callback;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} callback
     * @return {THIS}
     */
    setAllFilesUploadedCallback(callback) {
        (/** @type {?} */ (this))._allFilesUploadedCallback = callback;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} selector
     * @return {THIS}
     */
    setDragAndDropFlagSelector(selector) {
        (/** @type {?} */ (this))._dragAndDropFlagSelector = selector;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} callback
     * @return {THIS}
     */
    setDisallowedContentTypeErrorMessage(callback) {
        (/** @type {?} */ (this))._disallowedContentTypeErrorMessage = callback;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} callback
     * @return {THIS}
     */
    setDisallowedContentSizeErrorMessage(callback) {
        (/** @type {?} */ (this))._disallowedContentSizeErrorMessage = callback;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} fileUploadType
     * @return {THIS}
     */
    setFileUploadType(fileUploadType) {
        (/** @type {?} */ (this))._fileUploadType = fileUploadType;
        return (/** @type {?} */ (this));
    }
    // Getters.
    /**
     * @return {?}
     */
    getRequestUrl() {
        return this._requestOptions.url;
    }
    /**
     * @return {?}
     */
    getRequestOptions() {
        return this._requestOptions;
    }
    /**
     * @return {?}
     */
    getAllowedContentTypes() {
        return this._allowedContentTypes;
    }
    /**
     * @return {?}
     */
    getFileCountLimit() {
        return this._fileCountLimit;
    }
    /**
     * @return {?}
     */
    getFileSizeLimitMb() {
        return this._fileSizeLimitMb;
    }
    /**
     * @return {?}
     */
    getOnFileCountLimitExceeded() {
        return this._onFileCountLimitExceeded;
    }
    /**
     * @return {?}
     */
    getAllFilesQueuedCallback() {
        return this._allFilesQueuedCallback;
    }
    /**
     * @return {?}
     */
    getFileUploadedCallback() {
        return this._fileUploadedCallback;
    }
    /**
     * @return {?}
     */
    getAllFilesUploadedCallback() {
        return this._allFilesUploadedCallback;
    }
    /**
     * @return {?}
     */
    getDragAndDropFlagSelector() {
        return this._dragAndDropFlagSelector;
    }
    /**
     * @return {?}
     */
    getFileUploadType() {
        return this._fileUploadType;
    }
    /**
     * @return {?}
     */
    getFileInputElements() {
        return this._fileInputElements;
    }
    /**
     * @return {?}
     */
    getDefaultFileSource() {
        return this._defaultFileSource;
    }
    /**
     * @return {?}
     */
    getInputAccept() {
        return this._allowedContentTypes.join(',');
    }
    // Private methods.
    /**
     * @private
     * @param {...?} elements
     * @return {?}
     */
    _registerSources(...elements) {
        /** @type {?} */
        const inputElements = elements.filter((/**
         * @param {?} element
         * @return {?}
         */
        (element) => element && element.type && element.type === 'file'));
        /** @type {?} */
        const dropZoneElements = elements.filter((/**
         * @param {?} element
         * @return {?}
         */
        (element) => element && (!element.type || element.type !== 'file')));
        /** @type {?} */
        const mergeArgs = [];
        if ((!inputElements || !inputElements.length) && (!dropZoneElements || !dropZoneElements.length)) {
            throw new Error('You must pass in at least one file source.');
        }
        if (inputElements && typeof inputElements.forEach === 'function') {
            inputElements.forEach((/**
             * @param {?} inputElement
             * @return {?}
             */
            (inputElement) => {
                /** @type {?} */
                const inputFileUploadsStream = this._registerInput(inputElement);
                mergeArgs.push(inputFileUploadsStream);
            }));
        }
        if (dropZoneElements && typeof dropZoneElements.forEach === 'function') {
            dropZoneElements.forEach((/**
             * @param {?} element
             * @return {?}
             */
            (element) => {
                /** @type {?} */
                const dropZoneFileUploadsStream = this._registerDropZone(element);
                mergeArgs.push(dropZoneFileUploadsStream);
            }));
        }
        if (this._isSingleFileInput()) {
            this.setFileCountLimit(1);
        }
        mergeArgs.push(this._fileUploadsStreamResetSubject.asObservable());
        return merge(...mergeArgs)
            .pipe(this._concatFileUploadArrays());
    }
    /**
     * @private
     * @return {?}
     */
    _isSingleFileInput() {
        return this._fileInputElements.every((/**
         * @param {?} fileInputElement
         * @return {?}
         */
        (fileInputElement) => !fileInputElement.multiple));
    }
    /**
     * @private
     * @param {?} inputElement
     * @return {?}
     */
    _registerInput(inputElement) {
        /** @type {?} */
        const fileUploadsSubject = new Subject();
        this._fileInputElements = uniq([...this._fileInputElements, inputElement]);
        if (this._allowedContentTypes.length && this._allowedContentTypes.indexOf('*') === -1) {
            this._fileInputElements.forEach((/**
             * @param {?} fileInputElement
             * @return {?}
             */
            (fileInputElement) => {
                setAcceptAttribute(fileInputElement, this.getInputAccept());
            }));
        }
        // Note: If the user tries to upload the same file more than once in a row using
        // the same input, the input will only emit 'change' on the first attempt.
        fromEvent(inputElement, 'change').subscribe((/**
         * @return {?}
         */
        () => __awaiter(this, void 0, void 0, function* () {
            if (this._isSingleFileInput()) {
                fileUploadsSubject.next([]);
            }
            fileUploadsSubject.next(yield this._handleFilesAdded(inputElement));
        })));
        return fileUploadsSubject.asObservable()
            .pipe(map((/**
         * @param {?} fileUploads
         * @return {?}
         */
        (fileUploads) => fileUploads.filter((/**
         * @param {?} fileUpload
         * @return {?}
         */
        (fileUpload) => !fileUpload.isMarkedForRemoval)))));
    }
    /**
     * @private
     * @param {?} element
     * @return {?}
     */
    _registerDropZone(element) {
        /** @type {?} */
        const fileUploadsSubject = new Subject();
        this._fileDropZoneElements = uniq([...this._fileDropZoneElements, element]);
        /** @type {?} */
        let eventListenersMap;
        if (this._dropZoneEventListenersMap.has(element)) {
            eventListenersMap = this._dropZoneEventListenersMap.get(element);
        }
        else {
            this._dropZoneEventListenersMap.set(element, {});
            eventListenersMap = this._dropZoneEventListenersMap.get(element);
            eventListenersMap.dragenter = (/**
             * @param {?} e
             * @return {?}
             */
            (e) => this._stopDragEvent(e));
            eventListenersMap.dragover = (/**
             * @param {?} e
             * @return {?}
             */
            (e) => this._handleDragOver(e));
            eventListenersMap.dragleave = (/**
             * @param {?} e
             * @return {?}
             */
            (e) => this._handleDragLeave(e));
            eventListenersMap.drop = (/**
             * @param {?} e
             * @return {?}
             */
            (e) => __awaiter(this, void 0, void 0, function* () {
                fileUploadsSubject.next(yield this._handleDrop(e));
            }));
            Object.keys(eventListenersMap).forEach((/**
             * @param {?} eventName
             * @return {?}
             */
            (eventName) => {
                element.addEventListener(eventName, eventListenersMap[eventName], false);
            }));
        }
        this._fileUploadsStreamResetSubject.subscribe((/**
         * @return {?}
         */
        () => {
            eventListenersMap = this._dropZoneEventListenersMap.get(element);
            if (eventListenersMap) {
                Object.keys(eventListenersMap).forEach((/**
                 * @param {?} eventName
                 * @return {?}
                 */
                (eventName) => {
                    element.removeEventListener(eventName, eventListenersMap[eventName]);
                }));
            }
        }));
        return fileUploadsSubject.asObservable()
            .pipe(map((/**
         * @param {?} fileUploads
         * @return {?}
         */
        (fileUploads) => fileUploads.filter((/**
         * @param {?} fileUpload
         * @return {?}
         */
        (fileUpload) => !fileUpload.isMarkedForRemoval)))));
    }
    /**
     * @private
     * @template T
     * @param {?} observable
     * @param {?} successCallback
     * @param {?=} errorCallback
     * @return {?}
     */
    _subscribeTemporarily(observable, successCallback, errorCallback) {
        this._subscriptions.push(observable.subscribe((/**
         * @param {?} value
         * @return {?}
         */
        (value) => successCallback(value)), (/**
         * @param {...?} args
         * @return {?}
         */
        (...args) => typeof errorCallback === 'function' ? errorCallback(...args) : {})));
    }
    /**
     * @private
     * @param {?} _files
     * @return {?}
     */
    _createFileUploads(_files) {
        /** @type {?} */
        let files = (/** @type {?} */ (_files));
        if (_files instanceof FileList) {
            files = Array.from(_files);
        }
        // Filter out disallowed file types/sizes.
        /** @type {?} */
        const allowedFiles = [];
        for (const file of files) {
            /** @type {?} */
            const fileType = file.type;
            // First, check if the file is under the size limit.
            if (!this._fileSizeLimitMb || file.size < this._fileSizeLimitMb * BYTES_PER_MB) {
                // Then, check if the file type is supported.
                // FIXME(dmayerdesign): Look into why File.type is sometimes empty in Edge.
                // As a result, when the fileType is empty, we need to admit we don't know anything
                // about the file type and just allow the check to pass.
                if (fileType === ''
                    || !!this._allowedContentTypes.find((/**
                     * @param {?} contentType
                     * @return {?}
                     */
                    (contentType) => contentType === '*'))
                    || this._allowedContentTypes.some((/**
                     * @param {?} contentType
                     * @return {?}
                     */
                    (contentType) => contentType === fileType))) {
                    allowedFiles.push(file);
                }
                else {
                    /** @type {?} */
                    let errorMessage = `${file.name} failed to upload because its content type, ${fileType}, is not allowed.`;
                    if (this._disallowedContentTypeErrorMessage) {
                        errorMessage = this._disallowedContentTypeErrorMessage(file);
                    }
                    this._errorSubject.next(new DisallowedContentTypeError(errorMessage));
                }
            }
            else {
                /** @type {?} */
                let errorMessage = `${file.name} is larger than the limit of ${this._fileSizeLimitMb}MB for a single file. Please compress or split the file into smaller files.`;
                if (this._disallowedContentSizeErrorMessage) {
                    errorMessage = this._disallowedContentSizeErrorMessage(file);
                }
                this._errorSubject.next(new FileSizeLimitExceededError(errorMessage));
            }
        }
        /** @type {?} */
        const fileUploads = uniq(allowedFiles).map((/**
         * @param {?} file
         * @return {?}
         */
        (file) => {
            /** @type {?} */
            const initialFileUpload = (/** @type {?} */ (new this._fileUploadType(file)));
            /** @type {?} */
            const fileUploadSubject = new BehaviorSubject(initialFileUpload);
            this._fileUploadSubjectsMap.set(initialFileUpload.id, fileUploadSubject);
            return initialFileUpload;
        }));
        return of(fileUploads);
    }
    /**
     * @private
     * @param {?} fileUploadsStream
     * @return {?}
     */
    _streamFileUploads(fileUploadsStream) {
        return merge(fileUploadsStream, this._fileUploadsStreamResetSubject.asObservable(), fileUploadsStream.pipe(this._mergeIsMarkedForRemovalStreams()))
            .pipe(this._concatFileUploadArrays(), switchMap((/**
         * @param {?} fileUploads
         * @return {?}
         */
        (fileUploads) => {
            // If we have a callback to invoke, return an observable of the callback mapped to
            // the result of `_executeFileUploads`. Else, just return the result of
            // `_executeFileUploads`.
            if (typeof this._allFilesQueuedCallback === 'function'
                && fileUploads
                && fileUploads.length
                && fileUploads.some((/**
                 * @param {?} fileUpload
                 * @return {?}
                 */
                (fileUpload) => !fileUpload.uploadHasStarted))) {
                /** @type {?} */
                const allFilesQueuedCallbackResult = this._allFilesQueuedCallback(fileUploads.filter((/**
                 * @param {?} fileUpload
                 * @return {?}
                 */
                (fileUpload) => !fileUpload.uploadHasStarted)));
                /** @type {?} */
                let _fileUploadsStream;
                if (allFilesQueuedCallbackResult) {
                    if (typeof ((/** @type {?} */ (allFilesQueuedCallbackResult))).then === 'function') {
                        _fileUploadsStream = from((/** @type {?} */ (allFilesQueuedCallbackResult)));
                    }
                    else {
                        _fileUploadsStream = of((/** @type {?} */ (allFilesQueuedCallbackResult)));
                    }
                }
                else {
                    _fileUploadsStream = of(fileUploads);
                }
                return _fileUploadsStream
                    .pipe(switchMap((/**
                 * @param {?} _fileUploads
                 * @return {?}
                 */
                (_fileUploads) => this._executeFileUploads(_fileUploads))));
            }
            else {
                return this._executeFileUploads(fileUploads);
            }
        })), this._concatFileUploadArrays());
    }
    /**
     * @private
     * @param {?} _fileUploads
     * @return {?}
     */
    _createExecutedFileUploadsStream(_fileUploads) {
        /** @type {?} */
        const fileUploadStreams = _fileUploads
            .map((/**
         * @param {?} fileUpload
         * @return {?}
         */
        (fileUpload) => {
            if (!fileUpload.uploadHasStarted) {
                return this._executeFileUpload(fileUpload);
            }
            else {
                return of(fileUpload);
            }
        }));
        return combineLatest(fileUploadStreams);
    }
    /**
     * @private
     * @param {?} fileUploads
     * @return {?}
     */
    _executeFileUploads(fileUploads) {
        if (fileUploads === null || fileUploads.length === 0) {
            return of(fileUploads);
        }
        /** @type {?} */
        let fileUploadsStream = this._createExecutedFileUploadsStream(fileUploads);
        if (typeof this._allFilesUploadedCallback === 'function') {
            fileUploadsStream = fileUploadsStream
                .pipe(switchMap((/**
             * @param {?} _fileUploads
             * @return {?}
             */
            (_fileUploads) => {
                if (_fileUploads.every((/**
                 * @param {?} fileUpload
                 * @return {?}
                 */
                (fileUpload) => fileUpload.uploaded))) {
                    /** @type {?} */
                    const allFilesUploadedCallbackResult = this._allFilesUploadedCallback(_fileUploads);
                    if (allFilesUploadedCallbackResult) {
                        if (typeof ((/** @type {?} */ (allFilesUploadedCallbackResult))).then === 'function') {
                            return from((/** @type {?} */ (allFilesUploadedCallbackResult)));
                        }
                        else {
                            return of((/** @type {?} */ (allFilesUploadedCallbackResult)));
                        }
                    }
                }
                return of(_fileUploads);
            })));
        }
        return fileUploadsStream;
    }
    /**
     * @private
     * @param {?} fileUpload
     * @return {?}
     */
    _uploadFile(fileUpload) {
        /** @type {?} */
        let fileUploadSubject = this._fileUploadSubjectsMap.get(fileUpload.id);
        /** @type {?} */
        let request;
        if (this._uploadFileAsBody) {
            request = fileUpload.createRequestFileAsBody();
        }
        else {
            request = fileUpload.createRequest();
        }
        // TODO: Figure out why _fileUploadSubjectsMap sometimes doesn't have this entry.
        if (!fileUploadSubject) {
            fileUploadSubject = new BehaviorSubject(fileUpload);
            this._fileUploadSubjectsMap.set(fileUpload.id, fileUploadSubject);
        }
        /** @type {?} */
        const handleError = (/**
         * @param {?} errorResponse
         * @return {?}
         */
        (errorResponse) => {
            /** @type {?} */
            const _fileUpload = fileUploadSubject.getValue();
            _fileUpload.progress = {
                percent: 100,
                state: ProgressState.Failed
            };
            if (errorResponse) {
                _fileUpload.responseBody = errorResponse;
                _fileUpload.responseCode = errorResponse.status || errorResponse.code;
                this._errorSubject.next(errorResponse);
            }
            fileUploadSubject.next(_fileUpload);
        });
        this._subscribeTemporarily(fileUpload.executeStream, (/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const xhr = new XMLHttpRequest();
            /** @type {?} */
            const progressStream = fromEvent(xhr.upload, 'progress');
            /** @type {?} */
            const completedStream = fromEvent(xhr, 'load');
            /** @type {?} */
            const xhrErrorStream = fromEvent(xhr, 'error');
            xhr.withCredentials = fileUpload.requestOptions.withCredentials || false;
            this._subscribeTemporarily(merge(progressStream, completedStream)
                .pipe(delay(0), takeUntil(this._fileUploadsStreamResetSubject.asObservable())), (/**
             * @param {?} event
             * @return {?}
             */
            (event) => __awaiter(this, void 0, void 0, function* () {
                /** @type {?} */
                const _fileUpload = fileUploadSubject.getValue();
                /** @type {?} */
                const progressPercent = Math.round(100 * event.loaded / event.total);
                if (xhr.readyState !== 4 /* DONE */ && typeof progressPercent === 'number') {
                    _fileUpload.progress = {
                        percent: progressPercent,
                        state: ProgressState.InProgress
                    };
                    fileUploadSubject.next(_fileUpload);
                }
                else if (xhr.readyState === 4 /* DONE */
                    && _fileUpload.progress.state !== ProgressState.Completed) {
                    // The upload is complete.
                    /** @type {?} */
                    let responseBody;
                    /** @type {?} */
                    let responseStatus;
                    try {
                        responseBody = JSON.parse(xhr.response);
                    }
                    catch (_error) {
                        responseBody = xhr.response;
                    }
                    _fileUpload.progress = {
                        percent: 100,
                        state: ProgressState.Completed
                    };
                    if (xhr.status && xhr.status >= 200 && xhr.status <= 599) {
                        responseStatus = xhr.status;
                    }
                    else {
                        responseStatus = 500;
                    }
                    _fileUpload.response = new Response(responseBody, {
                        status: responseStatus,
                        statusText: xhr.statusText
                    });
                    _fileUpload.responseBody = responseBody;
                    _fileUpload.responseCode = xhr.status;
                    if (typeof this._fileUploadedCallback === 'function') {
                        /** @type {?} */
                        const fileUploadedCallbackResult = this._fileUploadedCallback(_fileUpload);
                        if (fileUploadedCallbackResult) {
                            if (typeof ((/** @type {?} */ (fileUploadedCallbackResult))).then
                                === 'function') {
                                ((/** @type {?} */ (fileUploadedCallbackResult)))
                                    .then((/**
                                 * @param {?} fileUploadFromCallback
                                 * @return {?}
                                 */
                                (fileUploadFromCallback) => {
                                    fileUploadSubject.next(fileUploadFromCallback);
                                }));
                            }
                            else {
                                fileUploadSubject.next((/** @type {?} */ (fileUploadedCallbackResult)));
                            }
                        }
                        else {
                            fileUploadSubject.next(_fileUpload);
                        }
                    }
                    else {
                        fileUploadSubject.next(_fileUpload);
                    }
                }
            })), (/**
             * @param {?} errorResponse
             * @return {?}
             */
            (errorResponse) => handleError(errorResponse)));
            this._subscribeTemporarily(xhrErrorStream, (/**
             * @param {?} xhrError
             * @return {?}
             */
            (xhrError) => {
                /** @type {?} */
                let errorMessage;
                try {
                    errorMessage = JSON.stringify(xhrError);
                }
                catch (error) {
                    errorMessage = 'There was an error serializing the error response.';
                }
                handleError(new Error(errorMessage));
            }));
            xhr.open(request.method, request.url, true);
            if (fileUpload.requestOptions.headers) {
                Object.keys(fileUpload.requestOptions.headers).forEach((/**
                 * @param {?} key
                 * @return {?}
                 */
                (key) => {
                    /** @type {?} */
                    const value = fileUpload.requestOptions.headers[key];
                    xhr.setRequestHeader(key, value);
                }));
            }
            xhr.send(request.body);
            fileUpload.isMarkedForRemovalStream
                .pipe(filter((/**
             * @param {?} isMarkedForRemoval
             * @return {?}
             */
            (isMarkedForRemoval) => isMarkedForRemoval)), take(1))
                .subscribe((/**
             * @return {?}
             */
            () => xhr.abort()));
            this._fileUploadsStreamResetSubject
                .pipe(take(1))
                .subscribe((/**
             * @return {?}
             */
            () => xhr.abort()));
        }));
        return fileUploadSubject.asObservable();
    }
    /**
     * @private
     * @param {?} fileUploadToExecute
     * @return {?}
     */
    _executeFileUpload(fileUploadToExecute) {
        if (!this._areRequestOptionsSet) {
            throw new MissingRequestOptionsError('Uploading is not allowed until request options are set using `setRequestOptions`');
        }
        // The upload is now considered started (even though no XHR stuff has happened yet).
        // TODO: Figure out why _fileUploadSubjectsMap sometimes doesn't have this entry.
        /** @type {?} */
        let fileUploadSubject;
        if (!this._fileUploadSubjectsMap.has(fileUploadToExecute.id)) {
            this._fileUploadSubjectsMap.set(fileUploadToExecute.id, new BehaviorSubject(fileUploadToExecute));
        }
        fileUploadSubject = this._fileUploadSubjectsMap.get(fileUploadToExecute.id);
        fileUploadToExecute.uploadHasStarted = true;
        fileUploadSubject.next(fileUploadToExecute);
        // Construct a request and send it.
        if (typeof this._requestOptionsFactory === 'function') {
            /** @type {?} */
            const existingRequestOptions = this._requestOptions || {};
            /** @type {?} */
            const requestOptionsFactoryReturnValue = this._requestOptionsFactory(fileUploadToExecute);
            /** @type {?} */
            let requestOptionsPromise;
            if (!requestOptionsFactoryReturnValue
                || typeof ((/** @type {?} */ (requestOptionsFactoryReturnValue))).then
                    !== 'function') {
                requestOptionsPromise = Promise.resolve(requestOptionsFactoryReturnValue);
            }
            else {
                requestOptionsPromise = (/** @type {?} */ (requestOptionsFactoryReturnValue));
            }
            requestOptionsPromise
                .then((/**
             * @param {?} requestOptions
             * @return {?}
             */
            (requestOptions) => {
                if (requestOptions) {
                    fileUploadToExecute.setRequestOptions(Object.assign({}, requestOptions, existingRequestOptions, { formData: Object.assign({}, requestOptions.formData, existingRequestOptions.formData) }));
                }
                this._uploadFile(fileUploadToExecute);
            }));
        }
        else {
            fileUploadToExecute.setRequestOptions((/** @type {?} */ (this._requestOptions)));
            this._uploadFile(fileUploadToExecute);
        }
        return fileUploadSubject.asObservable();
    }
    // Event handlers.
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    _handleDragOver(event) {
        if (this._canDragAndDrop()) {
            this._stopDragEvent(event);
            this._isDraggedOverSubject.next(true);
        }
    }
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    _handleDrop(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._canDragAndDrop()) {
                this._stopDragEvent(event);
                this._isDraggedOverSubject.next(false);
                return yield this._createFileUploads(event.dataTransfer.files).toPromise();
            }
            return [];
        });
    }
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    _handleDragLeave(event) {
        if (this._canDragAndDrop()) {
            this._stopDragEvent(event);
            this._isDraggedOverSubject.next(false);
        }
    }
    /**
     * @private
     * @param {?} inputElement
     * @return {?}
     */
    _handleFilesAdded(inputElement) {
        /** @type {?} */
        const files = Array.from(inputElement.files);
        return this._createFileUploads(files).toPromise();
    }
    // Helpers.
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    _stopEvent(event) {
        event.stopImmediatePropagation();
        event.preventDefault();
    }
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    _stopDragEvent(event) {
        if (this._canDragAndDrop()) {
            return this._stopEvent(event);
        }
    }
    /**
     * @private
     * @return {?}
     */
    _canDragAndDrop() {
        return !this._dragAndDropFlagSelector
            || !!document.querySelector(this._dragAndDropFlagSelector);
    }
    /**
     * @private
     * @return {?}
     */
    _getFileCountLimit() {
        switch (typeof this._fileCountLimit) {
            case 'number':
                return (/** @type {?} */ (this._fileCountLimit));
            case 'function':
                return ((/** @type {?} */ (this._fileCountLimit)))();
            default:
                return 0;
        }
    }
    /**
     * @private
     * @param {?} fileUploads
     * @return {?}
     */
    _exceedsFileCountLimit(fileUploads) {
        /** @type {?} */
        const fileCountLimit = this._getFileCountLimit();
        if (!!fileUploads
            && fileCountLimit > 0
            && fileUploads.length > fileCountLimit) {
            return true;
        }
        return false;
    }
    /**
     * @private
     * @return {?}
     */
    _mergeIsMarkedForRemovalStreams() {
        return flatMap((/**
         * @param {?} fileUploads
         * @return {?}
         */
        (fileUploads) => merge(...fileUploads.map((/**
         * @param {?} fileUpload
         * @return {?}
         */
        (fileUpload) => fileUpload.isMarkedForRemovalStream.pipe(filter((/**
         * @param {?} isMarkedForRemoval
         * @return {?}
         */
        (isMarkedForRemoval) => isMarkedForRemoval)), map((/**
         * @return {?}
         */
        () => fileUploads))))))));
    }
    /**
     * @private
     * @return {?}
     */
    _concatFileUploadArrays() {
        // This `scan` (which behaves similarly to `Array.prototype.reduce`) does the bulk
        // of state management for `Uploader`.
        //   - If our `fileUploadsStream` is coming from a file input's `change` event,
        //     we'll be receiving a new array based on `input.files` any time that `change`
        //     event fires. So we might get `[fileUpload1]`, then `[fileUpload1, fileUpload2]`,
        //     etc. But, since each `FileUpload` has a unique `id`, we can de-dupe--that
        //     happens here.
        //   - If the number of `FileUpload`s exceeds the file count limit, mark all
        //     newly-added ones for removal (already-executed uploads are left alone).
        //   - If the new accumulated array exceeds the file count limit, invoke the callback
        //     (and make sure it's only invoked once per attempt).
        return scan((/**
         * @param {?} _previousAccFileUploads
         * @param {?} _currentFileUploads
         * @return {?}
         */
        (_previousAccFileUploads, _currentFileUploads) => {
            if (!_currentFileUploads || !_currentFileUploads.length) {
                return [];
            }
            else {
                _currentFileUploads.forEach((/**
                 * @param {?} fileUpload
                 * @return {?}
                 */
                (fileUpload) => {
                    if (fileUpload.isMarkedForRemoval && this._fileUploadSubjectsMap.has(fileUpload.id)) {
                        this._fileUploadSubjectsMap.get(fileUpload.id).unsubscribe();
                        this._fileUploadSubjectsMap.delete(fileUpload.id);
                    }
                }));
            }
            /** @type {?} */
            const previousAccFileUploads = _previousAccFileUploads
                .filter((/**
             * @param {?} fileUpload
             * @return {?}
             */
            (fileUpload) => !fileUpload.isMarkedForRemoval));
            /** @type {?} */
            const currentFileUploads = _currentFileUploads
                .filter((/**
             * @param {?} fileUpload
             * @return {?}
             */
            (fileUpload) => !fileUpload.isMarkedForRemoval));
            /** @type {?} */
            const accFileUploads = uniq([...previousAccFileUploads, ...currentFileUploads]);
            /** @type {?} */
            const newFileUploads = currentFileUploads
                .filter((/**
             * @param {?} currentFileUpload
             * @return {?}
             */
            (currentFileUpload) => !previousAccFileUploads
                .find((/**
             * @param {?} fileUpload
             * @return {?}
             */
            (fileUpload) => fileUpload.id === currentFileUpload.id))));
            // If the number of file uploads exceeds the limit, remove all the newly-added
            // uploads.
            if (this._exceedsFileCountLimit(currentFileUploads)
                || this._exceedsFileCountLimit(accFileUploads)) {
                newFileUploads.forEach((/**
                 * @param {?} fileUpload
                 * @return {?}
                 */
                (fileUpload) => {
                    fileUpload.markForRemoval();
                }));
                if (typeof this._onFileCountLimitExceeded === 'function') {
                    this._onFileCountLimitExceeded(this._getFileCountLimit());
                }
                return previousAccFileUploads;
            }
            return accFileUploads;
        }), []);
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._isDraggedOverSubject;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._fileInputElements;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._defaultFileSource;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._fileDropZoneElements;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._fileUploadSubjectsMap;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._fileUploadsStreamResetSubject;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._errorSubject;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._areRequestOptionsSet;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._uploadFileAsBody;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._allowedContentTypes;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._fileCountLimit;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._fileSizeLimitMb;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._onFileCountLimitExceeded;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._requestOptions;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._requestOptionsFactory;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._fileUploadType;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._allFilesQueuedCallback;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._fileUploadedCallback;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._allFilesUploadedCallback;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._dropZoneEventListenersMap;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._dragAndDropFlagSelector;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._disallowedContentTypeErrorMessage;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._disallowedContentSizeErrorMessage;
    /**
     * @type {?}
     * @private
     */
    Uploader.prototype._subscriptions;
    /**
     * A stream indicating whether the user is currently dragging files over any registered drop zone.
     * @type {?}
     */
    Uploader.prototype.isDraggedOverStream;
    /**
     * A stream of any errors that occur during upload.
     * @type {?}
     */
    Uploader.prototype.errorStream;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IProgress() { }
if (false) {
    /** @type {?} */
    IProgress.prototype.percent;
    /** @type {?} */
    IProgress.prototype.state;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IUploadRequestOptions() { }
if (false) {
    /** @type {?} */
    IUploadRequestOptions.prototype.url;
    /** @type {?|undefined} */
    IUploadRequestOptions.prototype.method;
    /** @type {?|undefined} */
    IUploadRequestOptions.prototype.formData;
    /** @type {?|undefined} */
    IUploadRequestOptions.prototype.headers;
    /** @type {?|undefined} */
    IUploadRequestOptions.prototype.withCredentials;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 * @template FileUploadType
 */
function IUploaderConfig() { }
if (false) {
    /** @type {?|undefined} */
    IUploaderConfig.prototype.allowedContentTypes;
    /** @type {?|undefined} */
    IUploaderConfig.prototype.fileCountLimit;
    /** @type {?|undefined} */
    IUploaderConfig.prototype.fileSizeLimitMb;
    /** @type {?|undefined} */
    IUploaderConfig.prototype.dragAndDropFlagSelector;
    /** @type {?|undefined} */
    IUploaderConfig.prototype.uploadFileAsBody;
    /** @type {?|undefined} */
    IUploaderConfig.prototype.requestUrl;
    /** @type {?|undefined} */
    IUploaderConfig.prototype.requestOptions;
    /** @type {?|undefined} */
    IUploaderConfig.prototype.fileUploadType;
    /** @type {?|undefined} */
    IUploaderConfig.prototype.allFilesQueuedCallback;
    /** @type {?|undefined} */
    IUploaderConfig.prototype.fileUploadedCallback;
    /** @type {?|undefined} */
    IUploaderConfig.prototype.allFilesUploadedCallback;
    /** @type {?|undefined} */
    IUploaderConfig.prototype.onFileCountLimitExceeded;
    /** @type {?|undefined} */
    IUploaderConfig.prototype.disallowedContentTypeErrorMessage;
    /** @type {?|undefined} */
    IUploaderConfig.prototype.disallowedContentSizeErrorMessage;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { DisallowedContentTypeError, FileSizeLimitExceededError, FileUpload, FileUploadError, HttpMethod, MissingRequestOptionsError, ProgressState, Uploader, UploaderError };

